module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/tryout/pages/tryout-questions/tryout-read-questions/partial/tryout-add-standard/tryout-add-standard.component.css
// module id = ./src/app/tryout/pages/tryout-questions/tryout-read-questions/partial/tryout-add-standard/tryout-add-standard.component.css
// module chunks = main